import React from 'react'
import { Typography, Stack } from '@mui/material';

const RowSimple = ({ label, value }) => {
    return (
        <Stack>
            <Typography sx={{fontSize:8}}>{label}</Typography>
            <Typography sx={{fontSize:10, fontWeight:'medium'}}>{value}</Typography>
        </Stack>
    )
}

export default RowSimple;
